export default "__VITE_ASSET__COToUnFZ__"